import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { KnowledgePage, type KnowledgeSearchState } from '../features/knowledge/knowledge-page';

const KnowledgeSearchSchema = z.object({
  page: z.number().int().positive().catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).catch(25),
  status: z.enum(['PENDING', 'PROCESSING', 'READY', 'FAILED']).optional().catch(undefined),
});

export const Route = createFileRoute('/manage/$companySlug/projects/$projectId/knowledge')({
  component: KnowledgeRoute,
  validateSearch: zodValidator(KnowledgeSearchSchema),
});

function KnowledgeRoute() {
  const params = Route.useParams();
  const searchState: KnowledgeSearchState = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <KnowledgePage
      {...params}
      onPageChange={(page) => void navigate({ search: (previous) => ({ ...previous, page }) })}
      searchState={searchState}
    />
  );
}
